if (!customElements.get('sticky-header-alard')) {
  class StickyHeaderAlard extends HTMLElement {
    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      this.onMenuToggle = this.onMenuToggle.bind(this);
      this.headerSection = this.closest('.section-header');
      this.lastScrollPosition = window.scrollY;
      this.updateStickyState(window.scrollY, true);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('toggle', this.onMenuToggle, true);
      this.addEventListener('click', (event) => {
        const drawer = event.target.closest('.menu-drawer--alard');
        if (!drawer) return;
        const panel = drawer.querySelector('[data-store-selector]');
        const trigger = drawer.querySelector('[data-store-selector-open]');
        if (event.target.closest('[data-store-selector-open]')) {
          panel?.removeAttribute('hidden');
          trigger?.setAttribute('aria-expanded', 'true');
          panel?.querySelector('[data-store-selector-close]')?.focus();
        }
        if (event.target.closest('[data-store-selector-close]')) {
          panel?.setAttribute('hidden', '');
          trigger?.setAttribute('aria-expanded', 'false');
          trigger?.focus();
        }
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const panel = this.querySelector('[data-store-selector]:not([hidden])');
        if (!panel) return;
        panel.setAttribute('hidden', '');
        const trigger = this.querySelector('[data-store-selector-open]');
        trigger?.setAttribute('aria-expanded', 'false');
        trigger?.focus();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('toggle', this.onMenuToggle, true);
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(() => {
        this.updateStickyState(window.scrollY);
        this.scrollFrame = null;
      });
    }

    updateStickyState(currentScrollPosition, initial = false) {
      const isAtTop = currentScrollPosition <= 50;
      const isScrollingDown = currentScrollPosition > this.lastScrollPosition;
      const isScrollingUp = currentScrollPosition < this.lastScrollPosition;
      const hasOpenMegaMenu = Boolean(this.querySelector('.mega-menu[open]'));
      const hasOpenMobileDrawer = Boolean(this.querySelector('#Details-menu-drawer-container[open]'));
      const hasOpenNavigation = hasOpenMegaMenu || hasOpenMobileDrawer;

      this.classList.toggle('is-scrolled', !isAtTop);

      if (isAtTop || initial || isScrollingUp || hasOpenNavigation) {
        this.headerSection?.classList.remove('header-alard-is-hidden');
      } else if (isScrollingDown) {
        this.headerSection?.classList.add('header-alard-is-hidden');
        this.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      }

      this.lastScrollPosition = currentScrollPosition;
    }

    onMenuToggle(event) {
      if (event.target.matches('.menu-drawer__category')) {
        const currentCategory = event.target;
        currentCategory.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(currentCategory.open));

        if (currentCategory.open) {
          currentCategory
            .closest('.menu-drawer__menu')
            ?.querySelectorAll('.menu-drawer__category[open]')
            .forEach((category) => {
              if (category === currentCategory) return;
              category.removeAttribute('open');
              category.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
            });
        }
        return;
      }

      if (!event.target.matches('.mega-menu')) return;

      window.requestAnimationFrame(() => {
        const hasOpenMegaMenu = Boolean(this.querySelector('.mega-menu[open]'));
        this.classList.toggle('has-open-mega-menu', hasOpenMegaMenu);

        if (hasOpenMegaMenu) {
          this.headerSection?.classList.remove('header-alard-is-hidden');
        }
      });
    }
  }

  customElements.define('sticky-header-alard', StickyHeaderAlard);
}
